import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Alert } from 'antd';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';
import Booking from '../../components/Booking';

class ManageBooking extends React.Component {
  static propTypes = {
    match: PropTypes.object,
  };
  state = {
    bookings: [],
    plan: false,
    customer: false,
    error: false,
  };
  componentDidMount() {
    this.getBookings();
  }
  getBookings = async () => {
    try {
      const { id } = this.props.match.params;
      const plan = await fetch(`/provider/plan-bookings/${id}`);
      this.setState({
        plan,
        bookings: plan.Bookings,
        customer: plan.Customer,
      });
    } catch (e) {
      this.setState({ error: (e.error || e).toString() });
    }
  };
  breadcrumbs = [
    { name: 'Home', to: '/' },
    { name: 'Bookings', to: '/provider/bookings' },
    { name: 'Manage Bookings' },
  ];
  render() {
    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        {this.state.error && <Alert type="error" message={this.state.error} />}
        <div className={s.header}>Manage Booking</div>
        <div className={s.center}>
          <div>
            <div>Contract Number:</div>
            <div>Customer name:</div>
            <div>Phone:</div>
            <div>E-mail:</div>
          </div>
          <b>
            <div>{this.state.plan.contractNumber}</div>
            <div>
              {this.state.customer.firstName} {this.state.customer.lastName}
            </div>
            <div>
              {this.state.customer.mobilePhone || this.state.customer.phone}
            </div>
            <div>{this.state.customer.email}</div>
          </b>
        </div>
        <div className={s.bookings}>
          {this.state.bookings.map(x => (
            <Booking refresh={this.getBookings} key={x.id} item={x} />
          ))}
        </div>
      </NavBar>
    );
  }
}

export default withRouter(ManageBooking);
